import {gql} from "apollo-angular";
import {baseResponse} from "src/app/store/base.graphql";

const serviceGroupFields = `
    id
    requirementGroupUniqueId
    requirementGroupName
    requirementGroupRequirements {
        id
        requirementUniqueId
        requirementName
        requirementDescription
    }
`;

export const CREATE_SERVICE_REQUIREMENTS_GROUP = gql`
    mutation CreateServiceRequirementGroupMutation($input: ServiceRequirementGroupInputObjects) {
        createServiceRequirementGroupMutation(input: $input) {
            data{
                ${serviceGroupFields}
            }
            response {
                ${baseResponse}
            }
        }
    }
`;

export const UPDATE_SERVICE_REQUIREMENTS_GROUP = gql`
    mutation UpdateServiceRequirementGroupMutation($input: ServiceRequirementGroupInputObjects) {
        updateServiceRequirementGroupMutation(input: $input) {
            data{
                ${serviceGroupFields}
            }
            response {
                ${baseResponse}
            }
        }
    }
`;

export const GET_SERVICE_REQUIREMENTS_GROUPS = gql`
    query GetServiceRequirementGroups($filtering: ServiceRequirementFilteringInputObjects) {
        getServiceRequirementGroups(filtering: $filtering) {
            data{
                ${serviceGroupFields}
            }
            response {
                ${baseResponse}
            }
        }
    }
`;

export const DELETE_SERVICE_REQUIREMENTS_GROUP = gql`
    mutation DeleteServiceRequirementGroupMutation($requirementGroupUniqueId: String!) {
        deleteServiceRequirementGroupMutation(requirementGroupUniqueId: $requirementGroupUniqueId) {
            response {
                ${baseResponse}
            }
        }
    }
`;
